export default "__VITE_ASSET__BUmUIGye__"